import { render, staticRenderFns } from "./TenantCard.vue?vue&type=template&id=69e2d7c3"
import script from "./TenantCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports